import { put, call } from 'redux-saga/effects';
import { sectorList, sectorAllList ,sectorAdd, sectorEdit, sectorUpdate, sectorDelete } from '../../../services/settings/superadmin/sectorService';

import * as types from '../../../actions';

export function* sectorListSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(sectorList, payload);
      yield put({ type: types.SECTOR_LIST_SUPERADMIN_SUCCESS, response })
      
    } catch(error) {
      yield put({ type: types.SECTOR_LIST_SUPERADMIN_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* sectorAllListSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(sectorAllList, payload);
    yield put({ type: types.SECTOR_ALL_SUPERADMIN_LIST_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.SECTOR_ALL_SUPERADMIN_LIST_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* sectorAddSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(sectorAdd, payload);
      yield put({ type: types.SECTOR_ADD_SUPERADMIN_SUCCESS, response })
            
    } catch(error) {
      yield put({ type: types.SECTOR_ADD_SUPERADMIN_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* sectorEditSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(sectorEdit, payload);
    yield put({ type: types.SECTOR_EDIT_SUPERADMIN_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.SECTOR_EDIT_SUPERADMIN_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* sectorUpdateSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(sectorUpdate, payload);
    yield put({ type: types.SECTOR_UPDATE_SUPERADMIN_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.SECTOR_UPDATE_SUPERADMIN_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* sectorDeleteSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(sectorDelete, payload);
    yield put({ type: types.SECTOR_DELETE_SUPERADMIN_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.SECTOR_DELETE_SUPERADMIN_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}